import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, pluginsService } from '@v2/services';
import type { RemovePluginFromOfferingResponse } from '@v2/types';

export const useRemovePluginFromOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      offeringName,
      pluginId,
    }: {
      offeringName: string;
      pluginId: string;
    }) => pluginsService.removePluginFromOffering(offeringName, pluginId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(
        queryKeys.plugins.byOffering(variables.offeringName)
      );
    },
  });

  const removePluginFromOffering = async (
    offeringName: string,
    pluginId: string
  ): Promise<RemovePluginFromOfferingResponse | null> => {
    try {
      return await mutation.mutateAsync({ offeringName, pluginId });
    } catch {
      return null;
    }
  };

  return {
    removePluginFromOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useRemovePluginFromOffering;
